import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const DefaultRoute = () => {
  const { isAdmin, isEmployee } = useAuth();
  
  // Redirect admin users to admin page
  if (isAdmin()) {
    return <Navigate to="/admin" replace />;
  }
  
  // For employees, redirect to welcome page as default home page
  if (isEmployee()) {
    return <Navigate to="/welcome" replace />;
  }
  
  // Default to welcome page
  return <Navigate to="/welcome" replace />;
};

export default DefaultRoute;
